<template>
    <div>
        <el-input
            :placeholder="placeholder"
            :value="value"
            :disabled="disabled"
            :clearable="clearable"
            :size="size"
            :autosize="autosize"
            :type="type"
            @input="updateValue"
            :show-password="showPassword"
            v-bind="$attrs"
            :class="{ 'is-error': showError }"
        >
            <i
                v-if="
                    showCloseIcon === true &&
                    disabled === false &&
                    value &&
                    type !== 'textarea'
                "
                @click="clearInput"
                slot="suffix"
                class="el-input__icon el-icon-circle-close icon-close"
            >
            </i>
        </el-input>
        <i
            v-if="
                showCloseIcon === true &&
                disabled === false &&
                value &&
                type === 'textarea'
            "
            @click="clearInput"
            class="el-input__icon el-icon-circle-close icon-close-textarea"
        >
        </i>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: String,
        value: [String, Number],
        disabled: Boolean,
        clearable: Boolean,
        size: {
            type: String,
            default: 'small'
        },
        type: String,
        showPassword: Boolean,
        showCloseIcon: {
            type: Boolean,
            default: true
        },

        autosize: Object,
        showError: Boolean
    },
    methods: {
        updateValue(newValue) {
            // newValue = newValue.trim()
            this.$emit('input', newValue)
        },
        clearInput() {
            this.$emit('input', '')
        }
    }
}
</script>

<style scoped>
.icon-close,
.icon-close-textarea {
    color: #333;
    cursor: pointer;
}
.el-input {
    position: relative;
}

.el-input__icon.icon-close-textarea {
    top: 15px;
    position: absolute;

    transform: translateY(-50%);
    right: 15px;
    cursor: pointer;
}
::v-deep .is-error .el-input__inner {
    border: 1px solid #f56c6c !important;
}
::v-deep .is-error .el-input__inner:focus {
    border: 1px solid #f56c6c !important;
    box-shadow: 0 0 3px #f56c6c;
}
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: black;
}
::v-deep .el-input__inner {
    border: 1px solid #b2b7bd;
}
::v-deep .el-input__inner {
    color: #373333;
}

::v-deep .el-input__inner:focus {
    border: #409eff;
    box-shadow: 0 0 3px rgba(64, 158, 255, 0.5);
}

::v-deep .el-icon-view:before {
    color: black;
    content: '\e6ce';
}
</style>
